module.exports = "img/flags/DE.e4790ff.png";